import { ApiClient } from '../../../../../resources/shared/api/client';
import { getEnvRequired } from '../../../../../shared/utilities/env';

export type AT1ProposalResponseData = {
    content: string;
};

interface AT1ProposalJSONAPIResponse {
    data: {
        type: 'agent-first-message-for-dossier';
        id: string;
        attributes: AT1ProposalResponseData;
    };
    jsonapi: {
        version: string;
    };
}

const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');

const apiClient = new ApiClient(false);

export const fetchAT1Proposal = async (
    dossierId: number,
): Promise<AT1ProposalResponseData | null> => {
    const response = await apiClient.get<AT1ProposalJSONAPIResponse>(
        `${REQUEST_MANAGER_API_URL}/discussion/agent-first-message-proposal/${dossierId}`,
    );

    return response.data.attributes;
};
